import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueGtag from "vue-gtag";

Vue.config.productionTip = false
Vue.use(VueGtag, {
  config: { id: "UA-80233040-2" }
});

new Vue({
  router,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
